module.exports = __webpack_public_path__ + "static/media/ios-square-outline.9b4eecec.svg";